/* @flow */
import { pickClasses } from 'atpjs/wizard/choose_step'
import { existingCustomer } from 'tve/helpers/logic'

import Login from 'tve/views/steps/1_login'
import CustomerType from 'tve/views/steps/2_customer_type'
import Subject from 'tve/views/steps/3_subject'
import Branch from 'tve/views/steps/4_branch'
import Appointment from 'tve/views/steps/5_appointment'
import UserForm from 'tve/views/steps/6_user_form'
import Confirmation from 'tve/views/steps/7_confirmation'
import Update from 'tve/views/steps/8_update'
import Cancelled from 'tve/views/steps/9_cancelled'

import type { StepListType } from 'atpjs/wizard/current_step'
import type DataHandler from 'atpjs/data_handler'

export const classes: StepListType = [
  { name: 'login', class: Login },
  { name: 'customerType', class: CustomerType },
  { name: 'subject', class: Subject },
  { name: 'branch', class: Branch },
  { name: 'appointment', class: Appointment },
  { name: 'userForm', class: UserForm },
  { name: 'confirmation', class: Confirmation },
  { name: 'update', class: Update },
  { name: 'cancelled', class: Cancelled }
]

export default (data: DataHandler) => {
  return pickClasses(
    classes,
    [
      data.getIn(['advisor', 'branches']) ? null : 'login',
      existingCustomer(data) ? null : 'customerType',
      'subject',
      'branch',
      'appointment',
      'userForm',
      'confirmation',
      'cancelled',
      'update'
    ].filter(Boolean)
  )
}
